import { create } from 'zustand';

type Store = {
  isPending: boolean;
  setIsPending: (isPending: boolean) => void;
};

export const useClassConversionPendingStore = create<Store>()((set) => {
  return {
    isPending: false,
    setIsPending(isPending) {
      set(() => {
        return { isPending };
      });
    },
  };
});
